/* eslint-disable */
import React, { useMemo } from 'react'
import { pick } from 'lodash-es'
import { useTbViewStore, useProjectStore } from '@vt/hooks'
import { InlineRender } from '@ow/ditto'
import { Button } from '@ow/comps'
import { showDetail } from '../../details-copy'
import nullImg from '../../../assets/null.png'

const DefaultOperateComponent = ({
  onClickOpenDetail,
  rowData,
  operatorConfig = {},
}) => {
  const operators = (operatorConfig && operatorConfig.elements) || []
  const detailOpt = operators.find((v) => v.actionType === 'detailConfig')
  if (!detailOpt) {
    return null
  }

  return (
    <div>
      <Button
        type="primary"
        opacityType="transparent"
        style={{
          fontSize: '14px',
          margin: '0 -4px',
        }}
        onClick={() => {
          onClickOpenDetail(rowData)
        }}
      >
        查看详情
      </Button>
    </div>
  )
}
const TableContainer = function ({ showTbDetail, editTbData }) {
  const { tbData, fields, listConfig, destroyTbData, operatorConfig } =
    useTbViewStore((state) =>
      pick(state, [
        'destroyTbData',
        'tbData',
        'fields',
        'listConfig',
        'operatorConfig',
      ])
    )

  const { customCompsMap } = useProjectStore((state) =>
    pick(state, ['customCompsMap'])
  )

  const { OperateComponent } = customCompsMap || {}

  // 这个才是查看详情
  const showCurrentDataDetail = (_data) => {
    showDetail({ currentData: _data })
  }

  const operateProps = {
    onClickDestroyData: destroyTbData,
    onClickOpenDetail: showCurrentDataDetail,
    onClickUpdateData: editTbData,
  }

  const renderFields = useMemo(() => {
    if (listConfig && listConfig.fields) {
      return listConfig.fields
        .map((v) => {
          const obj = fields.find((f) => f.slug === v.slug)
          return obj
        })
        .map((v) => v)
    }
    return fields.filter((v) => {
      return !v.hidden
    })
  }, [fields])

  return (
    <div
      className="flex-1 w-full block md:hidden overflow-y-auto"
      style={{
        background: tbData.length === 0 ? '#fff' : 'rgb(233, 234, 238)',
      }}
    >
      <div
        className="w-full flex flex-col items-center"
        style={{ gap: '15px' }}
      >
        {tbData.length === 0 && (
          <>
            <img
              src={nullImg}
              style={{ width: '160px', height: '138px', marginTop: '168px' }}
            />
            <span
              style={{
                fontSize: '14px',
                color: 'rgba(0,0,0,0.90)',
                marginTop: '52px',
              }}
            >
              暂无数据
            </span>
          </>
        )}
        {tbData.map((item) => {
          operateProps.rowData = item
          operateProps.operatorConfig =
            operatorConfig && operatorConfig.operatorConfig

          return (
            <div
              style={{ borderRadius: '0', padding: '15px' }}
              className="w-full flex bg-white flex-wrap"
            >
              <div
                className="w-full flex mb-1 justify-end"
                style={{ color: 'rgba(0,0,0,0.40)', fontSize: '12px' }}
              >
                {OperateComponent ? (
                  <OperateComponent {...operateProps}>
                    <DefaultOperateComponent {...operateProps} />
                  </OperateComponent>
                ) : (
                  <DefaultOperateComponent {...operateProps} />
                )}
              </div>
              {renderFields.map((field, index) => {
                if (field) {
                  return (
                    <div
                      // key={field.slug}
                      className="w-1/2 flex mb-1 flex-col"
                      style={{ color: 'rgba(0,0,0,0.40)', fontSize: '12px' }}
                      key={`renderFields-${item.objectId}-${index}`}
                    >
                      <span
                        className="mb-1"
                        style={{ fontSize: '14px', color: 'rgba(0,0,0,0.90)' }}
                      >
                        {field.title}:
                      </span>
                      <InlineRender
                        value={item[field.slug]}
                        defs={{ ...field, 'inline-nowrap': false }}
                        rowData={item}
                        fields={fields}
                        className="flex flex-wrap"
                      />
                    </div>
                  )
                }
                return null
              })}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default TableContainer
